import { Baseurl } from "./url";
// refresh asks the backend to re-sync Hands-On Time from its wiki now, instead of
// waiting for its (short) cache to expire.
const getNearby = async (lat, lng, range, sources, refresh = false) => {

    var qs = ""
    var j = 0;
    for (j=0; j < sources.length; j++){
        qs += '&source=' + sources[j]; 
    }
//    const qs = '&sources=' + encodeURIComponent(JSON.stringify(sources))
    let url = `${Baseurl}/nearby?lat=${lat}&lng=${lng}&range=${range}${qs}${refresh ? '&refresh=true' : ''}`;

    let response = await fetch(url);

    if (response.ok) { // HTTP status is 200-299
        let json = await response.json();
        return json;
    }
    else {
        console.error(`HTTP Error: ${response.status}`);
        return {
            status: 400,
            query: {
                pages: []
            }
        };
    }
};

export default getNearby;
